<p-panel header="Results">
  <ng-template pTemplate="icons">
    <p-button
      [label]="'Refresh' | translateWF: 'Refresh'"
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      [disabled]="isLoading()"
      (click)="loadEmployeeMonthlyCosts()"
    />
    @if (!showUploadUi()) {
      <p-button [label]="'Add Excel' | translateWF: 'Add Excel'" icon="pi pi-plus" (click)="openUploadUi()" />
    }
  </ng-template>

  <p-card data-variant="compact">
    @if (!showUploadUi()) {
      <div>
        <p-table [value]="employeeMonthlyCosts()" [loading]="isLoading()">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'Employee Code' | translateWF: 'Employee Code' }}</th>
              <th>{{ 'Total Monthly Cost' | translateWF: 'Total Monthly Cost' }}</th>
              <th>{{ 'Currency' | translateWF: 'Currency' }}</th>
              <th>{{ 'Year' | translateWF: 'Year' }}</th>
              <th>{{ 'Month' | translateWF: 'Month' }}</th>
              <th>{{ 'Days Worked' | translateWF: 'Days Worked' }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ displayValue(row.employeeCode) }}</td>
              <td>{{ displayValue(row.totalMonthlyCost) }}</td>
              <td>{{ getCurrencyLabel(row.currency) }}</td>
              <td>{{ displayValue(row.year) }}</td>
              <td>{{ getMonthLabel(row.month) }}</td>
              <td>{{ displayValue(row.daysWorked) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    } @else {
      <div class="grid-12">
        <div class="span-12-3">
          <div class="form-box">
            <label for="month">{{ 'Employee_Costs_Month' | translateWF: 'Month' }} *</label>
            <p-dropdown
              [formControl]="month"
              [options]="monthOptions"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'Employee_Costs_Month' | translateWF: 'Month'"
              styleClass="w-full"
            />
          </div>
        </div>
        <div class="span-12-3">
          <div class="form-box">
            <label for="year">{{ 'Employee_Costs_Year' | translateWF: 'Year' }} *</label>
            <p-dropdown
              [formControl]="year"
              [options]="yearOptions"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'Employee_Costs_Year' | translateWF: 'Year'"
              styleClass="w-full"
            />
          </div>
        </div>
        <div class="span-12-3">
          <div class="form-box">
            <label for="year">{{ 'Employee_Costs_Currency' | translateWF: 'Currency' }} *</label>
            <p-dropdown
              [formControl]="currency"
              [options]="currencyOptions"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'Employee_Costs_Currency' | translateWF: 'Currency'"
              styleClass="w-full"
            />
          </div>
        </div>
      </div>

      <div class="drop__wrapper mt-6" [class.disabled]="!canUpload()">
        @if (!canUpload()) {
          <div class="drop__hint">
            <i class="pi pi-info-circle text-2xl mb-2"></i>
            <p>{{ 'Employee_Costs_Hint_Select_Month_Year_Currency' | translateWF: 'Select month, year, and currency first' }}</p>
          </div>
        } @else if (selectedFile) {
          <div class="drop__file">
            <i class="pi pi-file-excel text-2xl mr-2"></i>
            <span class="drop__file_name">{{ selectedFile.name }}</span>
            <p-button icon="pi pi-times" severity="secondary" [rounded]="true" [text]="true" (click)="clearFile()" [pTooltip]="'Cancel' | translateWF: 'Cancel'" />
          </div>
        } @else {
          <div class="drop__select">
            <i class="pi pi-cloud-upload text-3xl mb-2"></i>
            <p class="mb-2">{{ 'Employee_Costs_Drag_Drop' | translateWF: 'Select your Excel file ' }}</p>
            <label for="employee-costs-file-input" class="drop__select_label">
              <i class="pi pi-folder-open mr-2"></i>
              {{ 'Employee_Costs_Select_File' | translateWF: 'Select File' }}
            </label>
            <input id="employee-costs-file-input" type="file" accept=".xlsx" class="hidden" (change)="onFileChange($event)" />
          </div>
        }
      </div>

      <div class="row-between-center mt-4">
        <a href="assets/employee-costs-template.xlsx" download class="download__link">
          <i class="pi pi-download mr-2"></i>
          {{ 'Employee_Costs_Download_Template' | translateWF: 'Download Sample Template' }}
        </a>

        <div class="row-sm-start-center">
          <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" [outlined]="true" [disabled]="isLoading()" (click)="cancelUploadUi()" />
          <p-button [label]="'Employee_Costs_Import' | translateWF: 'Import'" icon="pi pi-upload" [disabled]="!canImport() || isLoading()" (click)="import()" />
        </div>
      </div>
    }
  </p-card>
</p-panel>
